import { app } from 'app/app';
import { AppController } from 'app/controller';
import { userWatchlist } from 'app/userWatchlist';
import { ENDPOINT_JOBS, ENDPOINT_USER_REGISTER, ENDPOINT_WATCHLIST } from 'app/endpoints';
import { TIME_SNACKBAR_MEDIUM, TIME_SNACKBAR_SHORT } from 'app/timings';
import { MasterLayout } from 'layout/master/main';
import { JobsSearchList } from 'module/jobsSearchList/main';
import { JobDetail } from 'module/jobDetail/main';
import { MemoDeleteModal } from 'module/memoDeleteModal/main';
import { MemoSaveModal } from 'module/memoSaveModal/main';
import { EmptyState } from 'module/emptyState/main';
import { JobsEmptyState } from 'module/jobsEmptyState/main';
import { LoadingOverlay } from 'module/loadingOverlay/main';
import { SubNavigation } from 'module/subNavigation/main';
import { getJson } from 'util/xhr';
import { mediaQueries } from 'util/mediaQueries';
import { user } from 'app/user';
import Stickyfill from 'stickyfilljs';
import { getParams, params as urlWithParams } from 'util/url';
import { sendPageView, setPageType } from 'util/googleAnalytics';
import deepEqual from 'util/deepEqual';
import './styles.scss';
import { hasConsentGrantedOrDenied, onConsentChange } from 'util/consent';
import { SmallFooter } from 'module/smallFooter/main';

let selectedJobId = false;
let noCache = false;
const TABNAV_MEMO_INDEX = 2;
const TEXTAREA_CHAR_LIMIT = 500;

class WatchlistIndexController extends AppController {
    ready() {
        let jobDetailContentActive = false;

        noCache = !!window.location.search.split('noCache=')[1];

        if (window.history.state && window.history.state.jobDetailContent) {
            jobDetailContentActive = window.history.state.jobDetailContent;
        }

        if (this.jobsSearchList) {
            this.props.jobsSearchRequest = this.jobsSearchList.pagination
                ? Object.assign(this.jobsSearchList.pagination.getJobsSearchProps())
                : {};
        }

        if (window.location.hash) {
            selectedJobId = window.location.hash.substring(1);
        }

        const addedJob = Boolean(getParams(window.location.search).addedJob);
        if (addedJob && user.isLoggedIn() && mediaQueries.isMobile()) {
            this.layout.showSnackbar(
                TIME_SNACKBAR_MEDIUM,
                false,
                false,
                false,
                false,
                'Der Job wurde gemerkt.',
                true,
                false,
                false,
                false,
                true,
            );
        }

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        this.initHistoryApi();

        if (selectedJobId && !this.emptyState) {
            this.openJobDetail(selectedJobId, true, true, jobDetailContentActive);
            if ((this.jobsSearchList ? this.jobsSearchList.insideListing(selectedJobId) : false)) {
                const url = `${ENDPOINT_JOBS}/${selectedJobId}`;
                setTimeout(() => {
                    setPageType(this.props.layout?.jobBundleLabel);
                    sendPageView(document.title, url);
                    if (this.jobDetail) this.jobDetail.sendShowEvents();
                }, 2000);
            }
        }

        if (hasConsentGrantedOrDenied()) {
            this.allowPointerEvents();
        }
        onConsentChange(() => {
            if (hasConsentGrantedOrDenied()) {
                this.allowPointerEvents();
            }
        });
    }

    onPopState(state) {
        if (!state) return; // hashbang fix
        const shareModalActive = state.shareModalOpen ? state.shareModalOpen : false;
        const deleteModalActive = state.deleteModal ? state.deleteModal : false;
        const saveModalActive = state.saveModal ? state.saveModal : false;
        delete state.shareModalOpen;
        delete state.deleteModal;
        delete state.saveModal;
        const oldSearchformProps = this.props.jobsSearchRequest;
        const equalPage = state.jobsSearchRequest?.page === this.props.jobsSearchRequest?.page;
        let jobDetailContentActive = state.jobDetailContent ? state.jobDetailContent.active : false;
        let infoBoxId = false;

        if (jobDetailContentActive && !this.jobsSearchList.insideListingWatched(state.jobDetailContent.jobDetail.id)
            && equalPage) {
            if (state.jobsSearchRequest && !state.jobsSearchList) {
                jobDetailContentActive = false;
                infoBoxId = state.jobDetailContent.jobDetail.id;
                delete state.jobDetailContent;
            }
        }

        this.setProps(state);

        const detailModalIsOpen = this.jobDetail?.props.modalOpen === true;
        let sendSearchRequest = true;

        if (window.location.hash) {
            selectedJobId = window.location.hash.substring(1);
            if (!jobDetailContentActive) {
                window.scrollTo(0, 0);
            }
        } else {
            selectedJobId = false;
            if (!mediaQueries.isMobile()) {
                this.jobsSearchList.removeHighlightedJobItems();
                window.scrollTo(0, 0);
            }
        }

        if (mediaQueries.isMobile()) {
            if (jobDetailContentActive) {
                if (!this.jobDetail.props.modalOpen) {
                    this.jobDetail.openModal();
                } else {
                    if (shareModalActive) {
                        this.jobDetail.openShareModal();
                    } else if (this.jobDetail.isShareModalOpen()) {
                        this.jobDetail.closeShareModal();
                    }
                    if (deleteModalActive || (this.deleteModal
                        ? this.deleteModal.isOpen() : false)) {
                        if (deleteModalActive) {
                            this.deleteModal.openModal();
                        } else if (this.deleteModal.isOpen()) {
                            this.deleteModal.closeModal();
                        }
                    }
                    if (saveModalActive || (this.saveModal
                        ? this.saveModal.isOpen() : false)) {
                        if (saveModalActive) {
                            this.saveModal.openModal();
                        } else if (this.saveModal.isOpen()) {
                            this.saveModal.closeModal();
                            if (this.saveModal.props.abortLinkClicked) {
                                this.saveModal.props.abortLinkClicked = false;
                                window.history.back();
                            }
                        }
                    }
                    return;
                }
                sendSearchRequest = false;
            } else if (!jobDetailContentActive || detailModalIsOpen) {
                this.jobDetail.closeModal();
            }
        }

        const tempSearchformState = { ...state.jobsSearchRequest };
        const isEqualJobsSearchRequest = deepEqual(oldSearchformProps, tempSearchformState);

        if (state.jobsSearchRequest && !state.jobsSearchList && sendSearchRequest) {
            // if we haz a searchrequest and no joblist we do jobsearch weeeeee
            this.sendSearchRequest(
                state.jobsSearchRequest,
                true,
                jobDetailContentActive,
                !isEqualJobsSearchRequest,
                infoBoxId,
            );
        } else if (!isEqualJobsSearchRequest) {
            sendPageView();
        }

        if (jobDetailContentActive) {
            const jobId = state.jobDetailContent.jobDetail.id;
            const { title } = state.layout.meta;

            const url = `${ENDPOINT_JOBS}/${jobId}`;
            setPageType(state.layout?.jobBundleLabel);
            sendPageView(title, url);
            if (this.jobDetail) this.jobDetail.sendShowEvents();
        }
    }

    domBindings() {
        return {
            subNavigation: '.c-watchlistIndex .m-subNavigation',
            jobsSearchList: '.c-watchlistIndex__jobsSearchList .m-jobsSearchList',
            jobDetailContainer: '.c-watchlistIndex__detail',
            jobDetail: '.c-watchlistIndex__detail .m-jobDetail',
            detailInner: '.c-watchlistIndex__detailInner',
            splitViewContainer: '.c-watchlistIndex__splitView',
            loadingOverlayDetail: '.c-watchlistIndex__detailInner .m-loadingOverlay',
            loadingOverlayListing: '.c-watchlistIndex__jobsSearchList .m-loadingOverlay',
            emptyState: '.c-watchlistIndex__emptyState .m-emptyState',
            jobsEmptyState: '.c-watchlistIndex__detailInner .m-jobsEmptyState',
            deleteModal: '.c-watchlistIndex__deleteModal .m-memoDeleteModal',
            saveModal: '.c-watchlistIndex__saveModal .m-memoSaveModal',
            smallFooter: '.c-watchlistIndex__footer .m-smallFooter',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        if (this.dom.jobsSearchList) {
            this.jobsSearchList = new JobsSearchList(this.dom.jobsSearchList);
        }
        if (this.dom.jobDetail) {
            this.jobDetail = new JobDetail(this.dom.jobDetail);
        }
        if (this.dom.emptyState) {
            this.emptyState = new EmptyState(this.dom.emptyState);
        }
        if (this.dom.jobsEmptyState) {
            this.jobsEmptyState = new JobsEmptyState(this.dom.jobsEmptyState);
        }
        if (this.dom.loadingOverlayDetail) {
            this.loadingOverlayDetail = new LoadingOverlay(this.dom.loadingOverlayDetail);
        }
        if (this.dom.loadingOverlayListing) {
            this.loadingOverlayListing = new LoadingOverlay(this.dom.loadingOverlayListing);
        }
        if (this.dom.subNavigation) {
            this.subNavigation = new SubNavigation(this.dom.subNavigation);
        }
        if (this.dom.detailInner) {
            Stickyfill.add(this.dom.detailInner);
        }
        if (this.dom.deleteModal) {
            this.deleteModal = new MemoDeleteModal(this.dom.deleteModal);
        }
        if (this.dom.saveModal) {
            this.saveModal = new MemoSaveModal(this.dom.saveModal);
        }
        if (this.dom.smallFooter) this.smallFooter = new SmallFooter(this.dom.smallFooter);
    }

    subsProps() {
        if (this.props.jobDetailContent) {
            this.jobDetail.setProps(this.props.jobDetailContent, true);
        }
        if (this.props.jobsSearchList) {
            this.jobsSearchList.updateProps(this.props.jobsSearchList, true);
        }
        if (this.props.jobsEmptyState) {
            this.jobsEmptyState.setProps(this.props.jobsEmptyState, true);
        }
        if (this.emptyState && this.emptyState.props.active) {
            this.layout.showFooter();
        } else {
            this.layout.hideFooter();
        }
    }

    subEvents() {
        this.layout.events.on('undo', (e) => {
            userWatchlist.addJob(e.arguments[0]);
        });

        if (this.jobsSearchList) {
            this.jobsSearchList.events.on('jobClick', (e) => {
                const jobId = e.arguments[0];
                if (jobId !== selectedJobId) {
                    this.openJobDetail(jobId);
                }
            });

            this.jobsSearchList.events.on('changed', (searchRequest) => {
                this.changedSearchRequest(searchRequest.arguments[0]);
            });

            this.jobsSearchList.events.on('removedJobItem', (e) => {
                const snackbarText = 'Der Job und deine dazugehörigen Notizen wurden entfernt.';
                const snackbarLinkEvent = 'click: revert-watchlist-job';

                this.layout.showSnackbar(
                    TIME_SNACKBAR_MEDIUM,
                    e.arguments[0],
                    false,
                    false,
                    false,
                    snackbarText,
                    false,
                    true,
                    snackbarLinkEvent,
                    'Rückgängig',
                    true,
                );
            });

            this.jobsSearchList.events.on('openMemoTab', (data) => {
                if (data.arguments[0] === selectedJobId) {
                    if (this.jobDetail.jobDetailContent.tabNav) {
                        this.jobDetail.jobDetailContent.tabNav.toggleTab(2);
                    }
                } else {
                    this.openJobDetail(data.arguments[0], false, false, false, true);
                }
            });
        }

        if (this.jobDetail) {
            this.jobDetail.events.on('pushState', () => {
                const props = { ...this.getProps() };
                props.shareModalOpen = true;
                const tempSearchFormProps = { ...this.props.jobsSearchRequest };
                this.pushState(
                    props,
                    this.props.layout.meta.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                    false,
                );
            });
            this.jobDetail.events.on('jobContentLoaded', () => {
                this.hideOverlay('detail');
            });
            this.jobDetail.events.on('jobContentLoading', () => {
                this.showOverlay('detail');
            });
            this.jobDetail.events.on('openDeleteModal', () => {
                this.deleteModal.openModalViaClick();
            });
            this.jobDetail.events.on('showSnackbar', () => {
                this.layout.showSnackbar(
                    TIME_SNACKBAR_SHORT,
                    false,
                    false,
                    false,
                    false,
                    'Deine Notizen wurden aktualisiert.',
                );
            });
            this.jobDetail.events.on('memoSaved', (e) => {
                this.jobsSearchList.updateShowMemoButtonStates(true, e.arguments[0]);
            });
            this.jobDetail.events.on('memoDeleted', (e) => {
                this.jobsSearchList.updateShowMemoButtonStates(false, e.arguments[0]);
            });
            this.jobDetail.events.on('showMemoOverlay', () => {
                this.showOverlay('detail');
            });
            this.jobDetail.events.on('hideMemoOverlay', () => {
                this.hideOverlay('detail');
            });
            this.jobDetail.events.on('openSaveModal', () => {
                let disabelSaveButton = false;
                if (this.jobDetail.getTextareaValue().length > TEXTAREA_CHAR_LIMIT) disabelSaveButton = true;
                this.saveModal.openModalViaClick(disabelSaveButton);
            });
        }

        if (this.deleteModal) {
            this.deleteModal.events.on('addModalStyle', () => {
                this.addModalStyles();
                this.layout.addModalStyle();
            });
            this.deleteModal.events.on('removeModalStyle', () => {
                this.removeModalStyles();
                this.layout.removeModalStyle();
            });
            this.deleteModal.events.on('deleteMemo', () => {
                this.jobDetail.deleteMemo();
                this.deleteModal.closeModalViaClick();
            });
            this.deleteModal.events.on('pushStateMemoDeleteModal', () => {
                const props = { ...this.getProps() };
                props.deleteModal = true;
                const tempSearchFormProps = { ...this.props.jobsSearchRequest };
                this.pushState(
                    props,
                    this.props.layout.meta.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                    false,
                );
            });
        }

        if (this.saveModal) {
            this.saveModal.events.on('addModalStyle', () => {
                this.addModalStyles();
                this.layout.addModalStyle();
            });
            this.saveModal.events.on('removeModalStyle', () => {
                this.removeModalStyles();
                this.layout.removeModalStyle();
            });
            this.saveModal.events.on('saveMemo', () => {
                this.jobDetail.saveMemo();
                this.saveModal.redirect();
            });
            this.saveModal.events.on('pushStateMemoSaveModal', () => {
                const props = { ...this.getProps() };
                props.saveModal = true;
                const tempSearchFormProps = { ...this.props.jobsSearchRequest };
                this.pushState(
                    props,
                    this.props.layout.meta.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                    false,
                );
            });
        }

        if (this.emptyState) {
            this.emptyState.events.on('emptyStateClick', () => {
                this.layout.openLoginModal(ENDPOINT_USER_REGISTER, false);
            });
            this.emptyState.events.on('openLoginModal', (e) => {
                this.layout.openLoginModal(e.arguments[0], e.arguments[1]);
            });
        }

        if (this.subNavigation && this.jobDetail) {
            this.subNavigation.events.on('subNavigationLinkClicked', (e) => {
                const similarMemo = this.jobDetail.memoContentSimilar();
                const activeTab = this.jobDetail.getActiveTab();
                let disabelActionButton = false;
                if (activeTab === TABNAV_MEMO_INDEX && !similarMemo) {
                    if (e.arguments[0]) e.arguments[0].preventDefault();
                    if (this.jobDetail.getTextareaValue().length > TEXTAREA_CHAR_LIMIT) disabelActionButton = true;
                    this.saveModal.openModalViaClick(disabelActionButton, e.arguments[0].currentTarget.href);
                }
            });
        }
    }

    openJobDetail(jobId, replaceState = false, onReady = false, jobDetailContentActive = false, openMemoTab = false) {
        this.showOverlay('detail');
        this.dom.splitViewContainer.classList.remove('c-watchlistIndex__splitView--seo');

        const url = noCache ? `${ENDPOINT_JOBS}/${jobId}?noCache=1` : `${ENDPOINT_JOBS}/${jobId}`;

        this.request = getJson(
            url,
            {},
            (response) => this.onJobDetailResponse(
                response,
                replaceState,
                onReady,
                jobDetailContentActive,
                openMemoTab,
            ),
            (error) => this.onJobDetailError(error),
        );
    }

    onJobDetailResponse(response, replaceState, onReady, jobDetailContentActive, openMemoTab) {
        const jobId = response.jobDetailContent.jobDetail.id;
        const { isInactive } = response.jobDetailContent.jobDetail;
        const { title } = response.layout.meta;
        this.request = false;

        if (!this.jobsSearchList.insideListing(jobId)) {
            let jobsInfoBox = {};

            if (isInactive) {
                jobsInfoBox = Object.assign(response.jobDetailContent.jobsInfoBox, { wrap: true });
            } else {
                jobsInfoBox = {
                    active: true,
                    wrap: true,
                    text: 'Der ausgeschriebene Job befindet sich nicht mehr in den aktuellen Suchergebnissen.',
                    link: {
                        active: true,
                        url: `/jobs/${jobId}`,
                        label: 'Job anzeigen',
                    },
                };
            }

            this.jobsSearchList.updateInfoBox(jobsInfoBox);

            const tempSearchFormProps = { ...this.props.jobsSearchRequest };
            const tempProps = { ...this.getProps(), jobsInfoBox };
            this.replaceState(
                tempProps,
                document.title,
                this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
            );
            this.hideOverlay('detail');
            return;
        }

        if (this.jobsEmptyState) {
            this.jobsEmptyState.updateProps({ active: false }, true);
            const jobsEmptyStateActive = this.props.jobsEmptyState ? this.props.jobsEmptyState.active : false;
            if (jobsEmptyStateActive) {
                this.props.jobsEmptyState.active = false;
            }
        }

        if (!mediaQueries.isMobile()) {
            if (this.props.jobsSearchList !== undefined) {
                this.props.jobsSearchList.activeItems.items = this.setHighlightProps(
                    this.props.jobsSearchList.activeItems.items,
                    jobId,
                );
                this.props.jobsSearchList.inactiveItems.items = this.setHighlightProps(
                    this.props.jobsSearchList.inactiveItems.items,
                    jobId,
                );
                this.props.jobsSearchList.jobSuggestions.items = this.setHighlightProps(
                    this.props.jobsSearchList.jobSuggestions.items,
                    jobId,
                );
            } else {
                this.jobsSearchList.highlightJobItem(jobId, onReady);
            }
        }

        const tempOldProps = { ...this.props };
        this.props = { ...this.props, ...response };
        response.jobDetailContent.openMemoTab = false;
        response.jobDetailContent.isWatchlist = true;
        response.jobDetailContent.jobDetail.noCache = noCache;
        if (this.jobsSearchList.jobsActiveList?.insideListing(response.jobDetailContent.jobDetail.id)
            || this.jobsSearchList.jobsInactiveList?.insideListing(response.jobDetailContent.jobDetail.id)) {
            response.jobDetailContent.tabs.push(
                { id: 'memoTab', label: 'Notizen', event: 'click: memo-tab', active: false },
            );
        }
        if (openMemoTab) response.jobDetailContent.openMemoTab = true;
        this.jobDetail.updateProps(response.jobDetailContent, true);
        if (!mediaQueries.isMobile() && this.jobsSearchList.jobsInfoBox
            && this.jobsSearchList.jobsInfoBox.props.active && !this.jobsSearchList.jobsInfoBox.props.concernsListing) {
            this.jobsSearchList.updateInfoBox({ active: false });
        }

        if (mediaQueries.isMobile()) {
            this.jobDetail.openModal();
        }

        selectedJobId = response.jobDetailContent.jobDetail.id;
        const tempSearchFormProps = { ...this.props.jobsSearchRequest };

        if (mediaQueries.isMobile() && onReady) {
            /* Two History entries are needed if the user bookmarks an opened jobDetail on his mobile phone.
            We write a second history entry, which allows us to close the jobDetail on history back and show the correct
            listing to the user.
            */

            if (jobDetailContentActive) {
                this.replaceState(
                    this.getProps(),
                    document.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                );
            } else {
                this.replaceState(
                    tempOldProps,
                    document.title,
                    this.generateCleanUrl(this.props.jobsSearchRequest, false),
                );
                this.pushState(
                    this.getProps(),
                    document.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                );
            }
        } else if (replaceState) {
            this.replaceState(
                this.getProps(),
                response.layout.meta.title,
                this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
            );
        } else {
            this.pushState(
                this.getProps(),
                response.layout.meta.title,
                this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                false,
            );
        }

        if (!onReady) {
            const url = `${ENDPOINT_JOBS}/${jobId}`;
            setPageType(response.layout?.jobBundleLabel);
            sendPageView(title, url);
            if (this.jobDetail) this.jobDetail.sendShowEvents();
        }
    }

    setHighlightProps(items, jobId) {
        for (let i = 0; i < items.length; i += 1) {
            if (items[i].jobsItem
                && items[i].jobsItem.id === jobId) {
                items[i].jobsItem.isHighlighted = true;
            } else if (items[i].jobsItem) {
                items[i].jobsItem.isHighlighted = false;
            }
        }
        return items;
    }

    onJobDetailError(error) {
        if (error.status === 0) {
            // aborted xhr ...
            return;
        }

        if (error.status === 404) {
            const data = error.errors[0];
            const viewData = data.meta ? data.meta.viewData : null;
            const tempSearchFormProps = { ...this.props.jobsSearchRequest };
            const tempProps = { ...this.getProps(), ...viewData };

            if (viewData && viewData.jobsInfoBox) {
                this.jobsSearchList.updateInfoBox(Object.assign(viewData.jobsInfoBox, { wrap: true }));
                this.replaceState(
                    tempProps,
                    document.title,
                    this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
                );
            } else {
                selectedJobId = false;
                this.replaceState(tempProps, document.title, this.generateCleanUrl(tempSearchFormProps));
            }
        }

        this.request = false;
        this.hideOverlay('detail');
    }

    changedSearchRequest(diffRequest) {
        this.showOverlay('listing');
        if (selectedJobId && !mediaQueries.isMobile()) {
            this.showOverlay('detail');
        }
        selectedJobId = false;
        this.props.jobsSearchRequest = {
            ...this.props.jobsSearchRequest, ...diffRequest };
        this.sendSearchRequest(this.props.jobsSearchRequest);
    }

    sendSearchRequest(
        searchRequest,
        replaceState = false,
        jobDetailContentActive = false,
        sendShowEvents = true,
        infoBoxId = false,
    ) {
        const endpoint = this.generateCleanUrl(searchRequest, true);
        if (this.searchRequest) {
            this.searchRequest.abort();
        }
        this.searchRequest = getJson(
            endpoint,
            {},
            (response) => this.onSearchResponse(
                response,
                replaceState,
                jobDetailContentActive,
                sendShowEvents,
                infoBoxId,
            ),
            (error) => this.onSearchResponseError(error, replaceState),
        );
    }

    onSearchResponse(
        responseJson,
        replaceState,
        jobDetailContentActive = false,
        sendShowEvents = true,
        infoBoxId = false,
    ) {
        // remove watchlist listeners for jobs everytime we render new jobs ...
        userWatchlist.events.removeAllListeners();

        const jobsInfoBoxActive = this.props.jobsInfoBox !== undefined;

        if (jobsInfoBoxActive) {
            if (responseJson.jobsSearchList !== undefined) {
                responseJson.jobsSearchList.jobsInfoBox = this.props.jobsInfoBox;
            }
            delete this.props.jobsInfoBox;
        }

        if (infoBoxId) {
            responseJson.jobsSearchList.jobsInfoBox = {
                active: true,
                wrap: true,
                text: 'Der ausgeschriebene Job befindet sich nicht mehr in den aktuellen Suchergebnissen.',
                link: {
                    active: true,
                    url: `/jobs/${infoBoxId}`,
                    label: 'Job anzeigen',
                },
            };
            window.scrollTo(0, 0);
        }

        if (jobDetailContentActive) {
            const activeItems = responseJson.jobsSearchList.activeItems.items;
            const inactiveItems = responseJson.jobsSearchList.inactiveItems.items;
            let jobIdInsideListing = false;

            for (let i = 0; i < activeItems.length; i += 1) {
                if (activeItems[i].jobsItem.id === selectedJobId) {
                    jobIdInsideListing = true;
                }
            }

            for (let i = 0; i < inactiveItems.length; i += 1) {
                if (inactiveItems[i].jobsItem.id === selectedJobId) {
                    jobIdInsideListing = true;
                }
            }

            if (sendShowEvents && !jobIdInsideListing) {
                responseJson.jobsSearchList.jobsInfoBox = {
                    active: true,
                    wrap: true,
                    text: 'Der ausgeschriebene Job befindet sich nicht mehr in den aktuellen Suchergebnissen.',
                    link: {
                        active: true,
                        url: `/jobs/${selectedJobId}`,
                        label: 'Job anzeigen',
                    },
                };
            } else {
                delete responseJson.layout;
                delete responseJson.jobDetailContent;
                if (!mediaQueries.isMobile()) {
                    if (responseJson.jobsEmptyState) responseJson.jobsEmptyState.active = false;
                    const jobId = this.props.jobDetailContent.jobDetail.id;
                    if (responseJson.jobsSearchList !== undefined) {
                        for (let i = 0; i < responseJson.jobsSearchList.activeItems.items.length; i += 1) {
                            const { jobsItem } = responseJson.jobsSearchList.activeItems.items[i];
                            if (jobsItem && jobsItem.id === jobId) {
                                responseJson.jobsSearchList.activeItems.items[i].jobsItem.isHighlighted = true;
                            } else if (jobsItem) {
                                responseJson.jobsSearchList.activeItems.items[i].jobsItem.isHighlighted = false;
                            }
                        }
                        for (let i = 0; i < responseJson.jobsSearchList.inactiveItems.items.length; i += 1) {
                            const { jobsItem } = responseJson.jobsSearchList.inactiveItems.items[i];
                            if (jobsItem && jobsItem.id === jobId) {
                                responseJson.jobsSearchList.inactiveItems.items[i].jobsItem.isHighlighted = true;
                            } else if (jobsItem) {
                                responseJson.jobsSearchList.inactiveItems.items[i].jobsItem.isHighlighted = false;
                            }
                        }

                        for (let i = 0; i < responseJson.jobsSearchList.jobSuggestions.items.length; i += 1) {
                            const { jobsItem } = responseJson.jobsSearchList.jobSuggestions.items[i];
                            if (jobsItem && jobsItem.id === jobId) {
                                responseJson.jobsSearchList.jobSuggestions.items[i].jobsItem.isHighlighted = true;
                            } else if (jobsItem) {
                                responseJson.jobsSearchList.jobSuggestions.items[i].jobsItem.isHighlighted = false;
                            }
                        }
                    }
                } else {
                    delete responseJson.jobsEmptyState;
                }
            }
        }

        this.updateProps(responseJson);

        // html5 history
        const tempSearchFormProps = { ...this.props.jobsSearchRequest };
        if (replaceState) {
            this.replaceState(
                this.getProps(),
                this.props.layout.meta.title,
                this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
            );
        } else {
            this.pushState(
                this.getProps(),
                this.props.layout.meta.title,
                this.generateCleanUrl(Object.assign(tempSearchFormProps, { selectedJobId })),
            );
        }

        this.hideOverlay('listing');
        this.hideOverlay('detail');
    }

    onSearchResponseError(error, replaceState) {
        if (error.status === 0) {
            // aborted xhr ...
            return;
        }

        this.updateProps({ error });

        const searchRequest = {
            page: 1,
        };

        if (replaceState) {
            this.replaceState(this.getProps(), `error ${error.status}`, this.generateCleanUrl(searchRequest));
        } else {
            this.pushState(this.getProps(), `error ${error.status}`, this.generateCleanUrl(searchRequest));
        }

        this.hideOverlay('detail');
        this.hideOverlay('listing');
    }

    generateCleanUrl(searchRequest, withSelectedJobId = true) {
        const urlParams = {};
        if (searchRequest.page > 1) {
            urlParams.page = searchRequest.page;
        }

        if (withSelectedJobId && searchRequest.selectedJobId) {
            return `${urlWithParams(ENDPOINT_WATCHLIST, urlParams)}#${searchRequest.selectedJobId}`;
        }

        return urlWithParams(ENDPOINT_WATCHLIST, urlParams);
    }

    hideOverlay(type) {
        if (mediaQueries.isMobile()) {
            if (type === 'listing') {
                this.loadingOverlayListing.hide();
                document.body.style.overflow = 'auto';
            }
            if (type === 'detail') {
                this.loadingOverlayDetail.hide();
            }
        } else if (type === 'listing') {
            this.loadingOverlayListing.hide();
        } else {
            this.loadingOverlayDetail.hide();
        }
    }

    showOverlay(type) {
        if (mediaQueries.isMobile()) {
            if (type === 'listing' && !this.loadingOverlayListing.props.visible) {
                window.scrollTo(0, 0);
                document.body.style.overflow = 'hidden';
                this.loadingOverlayListing.show();
            }
            if (type === 'detail' && !this.loadingOverlayDetail.props.visible) {
                this.loadingOverlayDetail.show();
            }
        } else if (type === 'listing' && !this.loadingOverlayListing.props.visible) {
            window.scrollTo(0, 0);
            this.loadingOverlayListing.show();
        } else if (!this.loadingOverlayDetail.props.visible) {
            this.loadingOverlayDetail.show();
        }
    }

    allowPointerEvents() {
        if (this.jobDetail) this.jobDetail.allowPointerEvents();
    }

    addModalStyles() {
        window.document.querySelector('.c-watchlistIndex__bgContainer')
            .classList.add('c-watchlistIndex__bgContainer--openModal');
    }

    removeModalStyles() {
        window.document.querySelector('.c-watchlistIndex__bgContainer')
            .classList.remove('c-watchlistIndex__bgContainer--openModal');
    }
}

app.boot(WatchlistIndexController);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(WatchlistIndexController);
    });

    module.hot.accept(() => {});
}
